import React from 'react';
import Loadable from 'react-loadable';
import { Redirect, Route, Switch } from 'react-router-dom';

import EditableRoute from '@components/EditableRoute';
import { QueueRoutes } from './constants';
import QueuePageWrapper from './components/PageWrapper';

const Loading = () => <div />;

const QueueDashboard = Loadable({
  loader: () => import('./pages/dashboard'),
  loading: Loading,
});

const QueueDashboardQuery = Loadable({
  loader: () => import('./pages/dashboard/components/QueryResultsTable'),
  loading: Loading,
});

const QueueSearch = Loadable({
  loader: () => import('./pages/queuesearch'),
  loading: Loading,
});

const QueueCodeFile = Loadable({
  loader: () => import('./pages/codefile'),
  loading: Loading,
});

const WorkTypes = Loadable({
  loader: () => import('./pages/worktypes'),
  loading: Loading,
});

const QueueSetting = Loadable({
  loader: () => import('./pages/queuesetting'),
  loading: Loading,
});

const MyQueue = Loadable({
  loader: () => import('./pages/myqueue'),
  loading: Loading,
});

const QueueView = Loadable({
  loader: () => import('./pages/queueview'),
  loading: Loading,
});

const QueueWorkItemView = Loadable({
  loader: () => import('./pages/queueworkitemview'),
  loading: Loading,
});

const BatchImport = Loadable({
  loader: () => import('./pages/batchimport'),
  loading: Loading,
});

const CopyAttachmentsToProperty = Loadable({
  loader: () => import('./pages/copyAttachmentsToProperty'),
  loading: Loading,
});

const BatchImportDetail = Loadable({
  loader: () => import('./pages/batchimport/EditProcessing'),
  loading: Loading,
});

const BatchImportDetailWorkItems = Loadable({
  loader: () => import('./pages/batchimport/ViewItems'),
  loading: Loading,
});

const WorkItemSearch = Loadable({
  loader: () => import('./pages/workitemsearch'),
  loading: Loading,
});

const Routes = () => (
  <Switch>
    <Route component={QueueView} exact path={QueueRoutes.NewQueueView} />
    <Route
      path="/queue"
      render={props => (
        <QueuePageWrapper {...props}>
          <Switch>
            <EditableRoute
              component={MyQueue}
              exact
              path={QueueRoutes.MyQueue}
            />
            <EditableRoute
              component={QueueDashboard}
              exact
              path={QueueRoutes.QueueDashboard}
            />
            <EditableRoute
              component={QueueDashboardQuery}
              exact
              path={QueueRoutes.QueueDashboardQuery}
            />
            <EditableRoute
              component={QueueSearch}
              exact
              path={QueueRoutes.QueueSearch}
            />
            <EditableRoute
              component={WorkItemSearch}
              exact
              path={QueueRoutes.WorkItemSearch}
            />
            <EditableRoute
              component={QueueCodeFile}
              exact
              path={QueueRoutes.CodefileMaintenance}
            />
            <EditableRoute
              component={WorkTypes}
              exact
              path={QueueRoutes.WorkTypes}
            />
            <EditableRoute
              component={QueueSetting}
              exact
              path={QueueRoutes.Queue}
            />
            <EditableRoute
              component={QueueView}
              exact
              path={QueueRoutes.QueueView}
            />
            <EditableRoute
              component={QueueWorkItemView}
              exact
              path={QueueRoutes.QueueWorkItemView}
            />
            <EditableRoute
              component={BatchImport}
              exact
              path={QueueRoutes.BatchImport}
            />
            <EditableRoute
              component={BatchImportDetail}
              exact
              path={QueueRoutes.BatchImportDetail}
            />
            <EditableRoute
              component={BatchImportDetailWorkItems}
              exact
              path={QueueRoutes.BatchImportDetailWorkItems}
            />
            <EditableRoute
              component={CopyAttachmentsToProperty}
              exact
              path={QueueRoutes.CopyAttachmentsToProperty}
            />
            <Redirect to={QueueRoutes.MyQueue} />
          </Switch>
        </QueuePageWrapper>
      )}
    />
  </Switch>
);

export default Routes;
